import { DELIVERED_SALES_ORDER_STATUS_IDS } from './receivable-statuses/delivered-sales-order-status-ids.js';
/** Why an order can't take a Create RMA, or null when it can; the API refuses with it and the web hides the action. */
export function salesOrderRmaRefusal({ statusId, path, }) {
    if (path === 'CreditReturn')
        return "A Credit Return can't be returned.";
    if (!DELIVERED_SALES_ORDER_STATUS_IDS.has(statusId)) {
        return 'Only a Shipped or Complete order can be returned.';
    }
    return null;
}
//# sourceMappingURL=sales-order-rma-refusal.js.map